import React, {FC, memo, useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";
import {actions as modal, IModal} from "../../store/sliceModal";
import {PageHomeDevices} from "./PageHomeStyle";
import Kettle from "../../component/kettle/Kettle";
import Reciver from "../../component/receiver/Receiver";
import SensorTemperature from "../../component/sensorTemperature/SensorTemperature";
import ModalKettle from "../../modal/modalKettle/ModalKettle";
import ModalReceiver from "../../modal/modalReceiver/ModalReceiver";
import { fetchDevices, fetchDeviceStatus } from "../../fetch/DeviceRequest";
import {actions, IDevice} from "../../store/sliceWebsocket";
import Relay from "../../component/relay/Relay";

const Page: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const modalWindow: IModal = useSelector((state: IRootState) => state.modal)
    const [device, setDevice] = useState<IDevice>({} as IDevice)
    useEffect(() => {
        fetchDevices().then(resp => {
            if (resp.status === 200) {
                const devices: IDevice = resp.data
                setDevice(devices)
                dispatch(actions.setDevices(devices))
                fetchDeviceStatus()
            }
        })
    },[])

    return (
        <>
            <PageHomeDevices>
                <Kettle/>
                <Reciver/>
                {device?.temperatures?.map((temperature) =>
                    <SensorTemperature key={temperature.deviceId} deviceId={temperature.deviceId}/>
                )}

                {device?.relays?.map((relay) =>
                    <Relay key={relay.deviceId} deviceId={relay.deviceId}/>
                )}
            </PageHomeDevices>
            <ModalKettle
                show={modalWindow.kettleModal}
                onHide={() => dispatch(modal.closeKettleModal())}
            />
            <ModalReceiver
                show={modalWindow.receiverModal}
                onHide={() => dispatch(modal.closeReceiverModal())}
            />

        </>

    )
}


export default memo(Page)

